/**
 * Check if a value is a number
 * @ignore
 * @param {*} value
 * @return {boolean}
 */
export default function isNumber(value) {
    return typeof value === 'number';
}
